var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user
    ? _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", [_vm._v(_vm._s(_vm.user.name))]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Имя")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:1|max:255",
                        expression: "'required|min:1|max:255'",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.name,
                        expression: "user.name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "user_n",
                      placeholder: "Имя пользователя",
                      "data-vv-as": "Имя пользователя",
                    },
                    domProps: { value: _vm.user.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.has("user_n")
                    ? _c("small", { staticClass: "form-text text-danger" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("user_n")) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Логин")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:1|max:255",
                        expression: "'required|min:1|max:255'",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.login,
                        expression: "user.login",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "user_l",
                      role: "presentation",
                      autoComplete: "off",
                      placeholder: "Логин пользователя",
                      "data-vv-as": "Логин пользователя",
                    },
                    domProps: { value: _vm.user.login },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "login", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.has("user_l")
                    ? _c("small", { staticClass: "form-text text-danger" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("user_l")) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Пароль")]),
                  _vm._v(" "),
                  !_vm.user.id
                    ? _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:1|max:255",
                            expression: "'required|min:1|max:255'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.password,
                            expression: "user.password",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          name: "pp",
                          role: "presentation",
                          autoComplete: "off",
                          "data-vv-as": "Пароль пользователя",
                          placeholder: "Пароль",
                        },
                        domProps: { value: _vm.user.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.user, "password", $event.target.value)
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.password,
                            expression: "user.password",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { placeholder: "Пароль", type: "password" },
                        domProps: { value: _vm.user.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.user, "password", $event.target.value)
                          },
                        },
                      }),
                  _vm._v(" "),
                  _vm.errors.has("pp")
                    ? _c("small", { staticClass: "form-text text-danger" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("pp")) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Подтверждение пароля"),
                  ]),
                  _vm._v(" "),
                  !_vm.user.id
                    ? _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:1|max:255",
                            expression: "'required|min:1|max:255'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.password_repeat,
                            expression: "user.password_repeat",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          name: "user_pass_repeat",
                          "data-vv-as": "Пароль пользователя",
                          placeholder: "Подтверждение пароля",
                        },
                        domProps: { value: _vm.user.password_repeat },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.user,
                              "password_repeat",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.password_repeat,
                            expression: "user.password_repeat",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          placeholder: "Подтверждение пароля",
                          type: "password",
                        },
                        domProps: { value: _vm.user.password_repeat },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.user,
                              "password_repeat",
                              $event.target.value
                            )
                          },
                        },
                      }),
                  _vm._v(" "),
                  _vm.errors.has("user_pass_repeat")
                    ? _c("small", { staticClass: "form-text text-danger" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("user_pass_repeat")) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Телефон")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.phone,
                        expression: "user.phone",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.phone },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "phone", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("E-mail")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email|max:255",
                        expression: "'required|email|max:255'",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "user_e",
                      "data-vv-as": "E-mail пользователя",
                      placeholder: "E-mail",
                    },
                    domProps: { value: _vm.user.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "email", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.has("user_e")
                    ? _c("small", { staticClass: "form-text text-danger" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("user_e")) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.$AllCities
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Город")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.details.city,
                              expression: "details.city",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.details,
                                "city",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _vm._l(_vm.$AllCities, function (city) {
                            return _c(
                              "option",
                              { domProps: { value: city.id } },
                              [_vm._v(_vm._s(city.name))]
                            )
                          }),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v("Другой город"),
                          ]),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Тип доступа"),
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        name: "user_role",
                        options: _vm.roles,
                        "data-vv-as": "Роль пользователя",
                        "track-by": "name",
                        label: "name_title",
                        "show-labels": false,
                        placeholder: "Выберите тип доступа",
                        multiple: true,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.arrangeBlocks()
                        },
                      },
                      model: {
                        value: _vm.user.roles,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "roles", $$v)
                        },
                        expression: "user.roles",
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.has("user_role")
                      ? _c("small", { staticClass: "form-text text-danger" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.errors.first("user_role")) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Комментарий")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.comment,
                        expression: "details.comment",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      rows: "3",
                      placeholder: "Дополнительный сведения пользователя",
                    },
                    domProps: { value: _vm.details.comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.details, "comment", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.salaryBlock.runner.show
            ? _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("ФИО для доверенности"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreementData.name,
                            expression: "agreementData.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.agreementData.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreementData,
                              "name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Паспортные данные"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreementData.passport,
                            expression: "agreementData.passport",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.agreementData.passport },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreementData,
                              "passport",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Данные доверенности"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-prepend" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "input-group-text",
                                on: { click: _vm.openPicker },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "pointer icon-fa icon-fa-calendar",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("datepicker", {
                              ref: "programaticOpen",
                              staticClass: "agreementDate",
                              attrs: { language: _vm.ru, "monday-first": true },
                              on: { input: _vm.updateDateText },
                              model: {
                                value: _vm.agreementData.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.agreementData, "date", $$v)
                                },
                                expression: "agreementData.date",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.agreementData.date_text,
                              expression: "agreementData.date_text",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", readonly: "" },
                          domProps: { value: _vm.agreementData.date_text },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.agreementData,
                                "date_text",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Прописка")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreementData.address,
                            expression: "agreementData.address",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.agreementData.address },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.agreementData,
                              "address",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card-body salary_block" }, [
                _vm.salaryBlock.runner.show
                  ? _c("div", [
                      _c("h6", [_vm._v(_vm._s(_vm.salaryBlock.runner.title))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "salary_runner" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Низкая ставка з/п"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_runner_low.basic,
                                  expression: "details.salary_runner_low.basic",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_runner_low.basic,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_low,
                                    "basic",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+ сумма *")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.salary_runner_low.percentage_1,
                                  expression:
                                    "details.salary_runner_low.percentage_1",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.details.salary_runner_low.percentage_1,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_low,
                                    "percentage_1",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+ (сумма-расходы) *")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.salary_runner_low.percentage_2,
                                  expression:
                                    "details.salary_runner_low.percentage_2",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.details.salary_runner_low.percentage_2,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_low,
                                    "percentage_2",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_runner_low.extra,
                                  expression: "details.salary_runner_low.extra",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_runner_low.extra,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_low,
                                    "extra",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("(ставка надбавки)")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Дальняя ставка"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_runner_region.basic,
                                  expression:
                                    "details.salary_runner_region.basic",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_runner_region.basic,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_region,
                                    "basic",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+ сумма *")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.salary_runner_region
                                      .percentage_1,
                                  expression:
                                    "details.salary_runner_region.percentage_1",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.details.salary_runner_region.percentage_1,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_region,
                                    "percentage_1",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+ (сумма-расходы) *")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.salary_runner_region
                                      .percentage_2,
                                  expression:
                                    "details.salary_runner_region.percentage_2",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.details.salary_runner_region.percentage_2,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_region,
                                    "percentage_2",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_runner_region.extra,
                                  expression:
                                    "details.salary_runner_region.extra",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_runner_region.extra,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_region,
                                    "extra",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("(ставка надбавки)")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Высокая ставка з/п"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_runner_high.basic,
                                  expression:
                                    "details.salary_runner_high.basic",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_runner_high.basic,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_high,
                                    "basic",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+ сумма *")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.salary_runner_high.percentage_1,
                                  expression:
                                    "details.salary_runner_high.percentage_1",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.details.salary_runner_high.percentage_1,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_high,
                                    "percentage_1",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+ (сумма-расходы) *")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.salary_runner_high.percentage_2,
                                  expression:
                                    "details.salary_runner_high.percentage_2",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.details.salary_runner_high.percentage_2,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_high,
                                    "percentage_2",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("+")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_runner_high.extra,
                                  expression:
                                    "details.salary_runner_high.extra",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_runner_high.extra,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_runner_high,
                                    "extra",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("(ставка надбавки)")]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.salaryBlock.manager.show
                  ? _c("div", [
                      _c("h6", [_vm._v(_vm._s(_vm.salaryBlock.manager.title))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex justify-content-between" },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Базовая зарплата"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_manager.basic,
                                  expression: "details.salary_manager.basic",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_manager.basic,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_manager,
                                    "basic",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Валюта"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.details.salary_manager.currency_id,
                                    expression:
                                      "details.salary_manager.currency_id",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.details.salary_manager,
                                      "currency_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.$AllCurrencies, function (currency) {
                                return _c(
                                  "option",
                                  { domProps: { value: currency.id } },
                                  [_vm._v(_vm._s(currency.currency))]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Коэффициент сдельной зарплаты"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.details.salary_manager.group_ratio,
                                  expression:
                                    "details.salary_manager.group_ratio",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.details.salary_manager.group_ratio,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.salary_manager,
                                    "group_ratio",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.salaryBlock.supervisor.show
                  ? _c("div", [
                      _c("h6", [
                        _vm._v(_vm._s(_vm.salaryBlock.supervisor.title)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          false
            ? _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Обычная")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.details.discount_normal.details,
                            expression: "details.discount_normal.details",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: {
                          value: _vm.details.discount_normal.details,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.details.discount_normal,
                              "details",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12 mb-3 text-right" }, [
            _c(
              "button",
              { staticClass: "btn btn-success", on: { click: _vm.updateUser } },
              [_vm._v("Сохранить")]
            ),
          ]),
          _vm._v(" "),
          _vm.chiefRunner
            ? _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            { attrs: { for: "exampleFormControlSelect1" } },
                            [_vm._v("Выберите склад")]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mainChiefStore,
                                  expression: "mainChiefStore",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { id: "exampleFormControlSelect1" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.mainChiefStore = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function ($event) {
                                    return _vm.fillUser()
                                  },
                                ],
                              },
                            },
                            _vm._l(_vm.stores, function (store, index) {
                              return _c(
                                "option",
                                { domProps: { value: store } },
                                [_vm._v(_vm._s(store.name))]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("h6", [_vm._v("Группа старшего курьера")]),
                            _vm._v(" "),
                            !_vm.mainChiefStore
                              ? _c("div", [
                                  _c("h5", [
                                    _vm._v(
                                      "Выберите склад для выбора курьеров"
                                    ),
                                  ]),
                                ])
                              : _vm._l(
                                  _vm.runnersInCity,
                                  function (runner, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "form-check" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.mainChiefSelectedRunners[
                                                  runner.id
                                                ],
                                              expression:
                                                "mainChiefSelectedRunners[runner.id]",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: `runnerCheck_${runner.id}`,
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.mainChiefSelectedRunners[
                                                runner.id
                                              ]
                                            )
                                              ? _vm._i(
                                                  _vm.mainChiefSelectedRunners[
                                                    runner.id
                                                  ],
                                                  null
                                                ) > -1
                                              : _vm.mainChiefSelectedRunners[
                                                  runner.id
                                                ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.mainChiefSelectedRunners[
                                                    runner.id
                                                  ],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.mainChiefSelectedRunners,
                                                      runner.id,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.mainChiefSelectedRunners,
                                                      runner.id,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.mainChiefSelectedRunners,
                                                  runner.id,
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "form-check-label pointer",
                                            attrs: {
                                              for: `runnerCheck_${runner.id}`,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(runner.name) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("h6", [_vm._v("Допустимые валюты расходов")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(
                            _vm.currencies,
                            function (currency, id, index) {
                              return _c("div", { staticClass: "form-check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedCurrencies[id],
                                      expression: "selectedCurrencies[id]",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: `currencyCheck_${index}`,
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.selectedCurrencies[id]
                                    )
                                      ? _vm._i(
                                          _vm.selectedCurrencies[id],
                                          null
                                        ) > -1
                                      : _vm.selectedCurrencies[id],
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedCurrencies[id],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedCurrencies,
                                              id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedCurrencies,
                                              id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedCurrencies,
                                          id,
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label pointer",
                                    attrs: { for: `currencyCheck_${index}` },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(currency) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("h6", [_vm._v("Допустимые расходы")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(
                            _vm.expensesTypes,
                            function (expence, id, index) {
                              return _c("div", { staticClass: "form-check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedExpensesTypes[id],
                                      expression: "selectedExpensesTypes[id]",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: `expensesCheck_${index}`,
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.selectedExpensesTypes[id]
                                    )
                                      ? _vm._i(
                                          _vm.selectedExpensesTypes[id],
                                          null
                                        ) > -1
                                      : _vm.selectedExpensesTypes[id],
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedExpensesTypes[id],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedExpensesTypes,
                                              id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedExpensesTypes,
                                              id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedExpensesTypes,
                                          id,
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label pointer",
                                    attrs: { for: `expensesCheck_${index}` },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(expence) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h6", [
                  _vm._v("Файлы\n            "),
                  _vm.existUploadedFiles()
                    ? _c(
                        "button",
                        {
                          staticClass: "float-right btn btn-info btn-sm",
                          on: { click: _vm.uploadUserFiles },
                        },
                        [
                          _vm._v(
                            "\n              Подгрузить файлы\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("uploadImage", {
                    ref: "uploadFilesBlock",
                    attrs: {
                      savedFiles: _vm.savedFiles,
                      uploadUserFiles: _vm.uploadUserFiles,
                      userId: _vm.id,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Авторизация")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Связь")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Данные пользователя")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Данные для начисления зарплаты:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Возможные скидки")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Большая")]),
      _vm._v(" "),
      _c("input", { staticClass: "form-control", attrs: { type: "number" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Максимально возможная")]),
      _vm._v(" "),
      _c("input", { staticClass: "form-control", attrs: { type: "number" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Личный ДИСКОНТНЫЙ пароль")]),
      _vm._v(" "),
      _c("input", { staticClass: "form-control", attrs: { type: "text" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Главный курьер")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }